import Splide from '@splidejs/splide';

const initArticleSliders = () => {
  document.querySelectorAll('.js-article-slider').forEach((el) => {
    new Splide(el, {
      type: 'slide',
      fixedWidth: '302px',
      perMove: 1,
      gap: '16px',
      // 最後のスライドが画面右端に密着しないよう、トラック末尾に余白を確保
      // （ページ左ガターと同じ16px。途中スライドのはみ出し演出はそのまま）
      padding: { right: '16px' },
      // スワイプ時に勢いで複数枚飛ばないよう、フリックの移動量を抑える
      // （perMoveはドラッグには効かないため flickPower / flickMaxPages で制御）
      flickPower: 100,
      flickMaxPages: 1,
      pagination: true,
      arrows: false,
      mediaQuery: 'min',
      breakpoints: {
        1025: {
          destroy: true,
        },
      },
    }).mount();
  });
};

export default initArticleSliders;
